// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "[dir] .dark-layout .card-company-table[data-v-b43d1d46]  td .b-avatar.badge-light-company {\n  background: #161d31 !important;\n}", ""]);
// Exports
module.exports = exports;
